import type { GisPeriod, GisPresetPeriod } from '../api/types'

const LABELS: Record<GisPresetPeriod, string> = {
  '7d': 'Last 7 days',
  '30d': 'Last 30 days',
  '90d': 'Last 90 days',
  fy: 'Fiscal Year',
}

/**
 * Human label for a GIS period: the preset name, or the active custom range (MM-DD – MM-DD). Shared by
 * the toolbar `PeriodDropdown` trigger and the Coverage card header so both read identically. Falls back
 * to "Last 30 days" for an unknown preset / a custom range with no dates yet.
 */
export function periodLabel(period: GisPeriod, from?: string, to?: string): string {
  if (period === 'custom') {
    return from && to ? `${from.slice(5)} – ${to.slice(5)}` : 'Custom Range'
  }
  return LABELS[period as GisPresetPeriod] ?? 'Last 30 days'
}
